import { PET_SCALE_MULTIPLIER, PET_SIZE_PERCENT_PER_CARD } from "@/pet/constants";
import type { PetDefinition } from "@/pet/types";

export function petDisplayScaleMultiplier(pet: PetDefinition | null | undefined): number {
  if (!pet) return PET_SCALE_MULTIPLIER;
  const cards = Math.max(0, Math.floor(pet.sizeCardsApplied ?? 0));
  return PET_SCALE_MULTIPLIER * (1 + (PET_SIZE_PERCENT_PER_CARD / 100) * cards);
}
